import tmhRequest from '@/config/tmhRequest'

export default {

    searchPayType: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/paytype/searchpaytype',
            method: 'post',
            params: data,
        })
    },

    searchListPayType: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/paytype/searchlistpaytype',
            method: 'post',
            params: data,
        })
    },

    searchListPayTypeTree: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/paytype/searchlistpaytypetree',
            method: 'post',
            params: data,
        })
    },

    addPayType: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/paytype/addpaytype',
            method: 'post',
            params: data,
        })
    },

    editPayType: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/paytype/editpaytype',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/baseinfo/paytype.js